import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/integration-systems/integration-dropdown-button/integration-dropdown-button.js';
      import {ObcIntegrationDropdownButtonChangeEvent} from '@oicl/openbridge-webcomponents/dist/integration-systems/integration-dropdown-button/integration-dropdown-button.js';
import {HTMLTemplateResult} from 'lit';

      export interface Props {
     options?: { value: string; label: string; status?: string | undefined; icon: HTMLTemplateResult; disabled?: boolean | undefined; }[];
     hasFleet?: boolean;
     fleetLabel?: string;
     value?: string | undefined;
     placeholder?: string;
     disabled?: boolean;
     fullWidth?: boolean;
     openTop?: boolean
   }

      
  
      export type {ObcIntegrationDropdownButtonChangeEvent} from '@oicl/openbridge-webcomponents/dist/integration-systems/integration-dropdown-button/integration-dropdown-button.js';
export type {HTMLTemplateResult} from 'lit';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcIntegrationDropdownButton',
  props: {
    options: {},
    hasFleet: { type: Boolean },
    fleetLabel: {},
    value: {},
    placeholder: {},
    disabled: { type: Boolean },
    fullWidth: { type: Boolean },
    openTop: { type: Boolean }
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onChange: (event: ObcIntegrationDropdownButtonChangeEvent) => emit('change', event as ObcIntegrationDropdownButtonChangeEvent)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-integration-dropdown-button',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})